import { Buffer as NodeBuffer } from 'buffer';
if (typeof global !== 'undefined') {
    global.Buffer = global.Buffer || NodeBuffer;
}
else if (typeof window !== 'undefined') {
    window.Buffer = window.Buffer || NodeBuffer;
    window.global = window.global || window;
}
else {
    self.Buffer = self.Buffer || NodeBuffer;
    self.global = self.global || self;
}
export const is2FAEnabled = false;
export var Environment;
(function (Environment) {
    // Internal Environments
    Environment["DEV"] = "DEV";
    Environment["SANDBOX"] = "SANDBOX";
    Environment["BETA"] = "BETA";
    Environment["PROD"] = "PROD";
    // Customer-Facing Environments
    // NOTE: these resolve to the corresponding internal environments for convenience
    Environment["DEVELOPMENT"] = "BETA";
    Environment["PRODUCTION"] = "PROD";
})(Environment || (Environment = {}));
export var OAuthMethod;
(function (OAuthMethod) {
    OAuthMethod["GOOGLE"] = "GOOGLE";
    OAuthMethod["TWITTER"] = "TWITTER";
    OAuthMethod["APPLE"] = "APPLE";
    OAuthMethod["DISCORD"] = "DISCORD";
    OAuthMethod["FACEBOOK"] = "FACEBOOK";
})(OAuthMethod || (OAuthMethod = {}));
export function getPortalDomain(env) {
    switch (env) {
        case Environment.DEV:
            return 'localhost';
        case Environment.SANDBOX:
            return 'app.sandbox.usecapsule.com';
        case Environment.BETA:
            return 'app.beta.usecapsule.com';
        case Environment.PROD:
            return 'app.usecapsule.com';
        default:
            throw new Error(`env: ${env} not supported`);
    }
}
export function getPortalBaseURL({ env }, useLocalIp) {
    const domain = getPortalDomain(env);
    if (env === Environment.DEV) {
        if (useLocalIp) {
            return `http://127.0.0.1:3003`;
        }
        return `http://${domain}:3003`;
    }
    return `https://${domain}`;
}
